const jquery = $;

const handleSetRealizationSort = () => {
  const tableWrapper = $('.sylius-grid-table-wrapper');
  const items = tableWrapper.find('.item');

  const values = [];

  items.each(function () {
      const inputSequence = $(this).find('.app-realization-sequence-input');
      values.push(parseInt(inputSequence.val()))
  })

  let minValue = Math.min(...values);

  const reverseItems = $(items.get().reverse());

  reverseItems.each(function () {
    const item = $(this);

    const sequenceHandle = item.find('.app-realization-sequence-handle');
    const sequenceInput = item.find('.app-realization-sequence-input');

    sequenceHandle.html(minValue)
    sequenceInput.val(minValue)

    minValue++;
  })
}

$.fn.extend({
  handleInitRealizationSortableList() {
    const inputsSequence = $('.app-realization-sequence-input');

    if (!inputsSequence.length) return;

    const tableWrapper = document.querySelector('.sylius-grid-table-wrapper');
    const sortableLists = tableWrapper.querySelectorAll('tbody');

    sortableLists.forEach(sortableList => {
      Sortable.create(sortableList, {
        handle: '.app-realization-sequence-handle',
        animation: 150,
        onEnd: handleSetRealizationSort
      });
    })
  },
  handleInitRealizationSequenceForm() {
    $('.app-update-realizations').on('submit', function (event) {
      event.preventDefault();

      const realizations = [];
      const form = $(this);

      $('.app-realization-sequence-input').each(function () {
        const inputSequence = $(this);

        realizations.push({
          id: inputSequence.attr('data-id'),
          sequence: inputSequence.val(),
        })
      })

      $.ajax({
        method: 'PUT',
        url: form.attr('action'),
        data: { realizations },
        success() {
          window.location.reload();
        },
      });
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleInitRealizationSortableList();
  jquery(document).handleInitRealizationSequenceForm();
});
